// @ts-nocheck

import { Route as rootRoute } from '../routes/__root';
import { Route as AdminPassportOrdersRoute } from '../routes/admin/passport-orders';
import { Route as AdminTagsRoute } from '../routes/admin/tags';
import { Route as AdminTransfersRoute } from '../routes/admin/transfers';
import { Route as AdminTransfersTransferIdRoute } from '../routes/admin/transfers.$transferId';
import { Route as CertificateCodeRoute } from '../routes/certificate/$code';
import { Route as MarketplaceArtworkIdRoute } from '../routes/marketplace/$artworkId';
import { Route as MarketplaceIndexRoute } from '../routes/marketplace/index';
import { Route as PassportPassportIdRoute } from '../routes/passport/$passportId';
import { Route as PassportOrderOrderIdRoute } from '../routes/passport/order.$orderId';
import { Route as PassportTransferTransferIdRoute } from '../routes/passport/transfer.$transferId';
import { Route as TransferTransferIdRoute } from '../routes/transfer.$transferId';
import { Route as VerifyUuidRoute } from '../routes/verify/$uuid';

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/marketplace/': {
      id: '/marketplace/';
      path: '/marketplace';
      fullPath: '/marketplace';
      preLoaderRoute: typeof MarketplaceIndexRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/transfers': {
      id: '/admin/transfers';
      path: '/admin/transfers';
      fullPath: '/admin/transfers';
      preLoaderRoute: typeof AdminTransfersRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/passport-orders': {
      id: '/admin/passport-orders';
      path: '/admin/passport-orders';
      fullPath: '/admin/passport-orders';
      preLoaderRoute: typeof AdminPassportOrdersRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/tags': {
      id: '/admin/tags';
      path: '/admin/tags';
      fullPath: '/admin/tags';
      preLoaderRoute: typeof AdminTagsRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/transfers/$transferId': {
      id: '/admin/transfers/$transferId';
      path: '/admin/transfers/$transferId';
      fullPath: '/admin/transfers/$transferId';
      preLoaderRoute: typeof AdminTransfersTransferIdRoute;
      parentRoute: typeof rootRoute;
    };
    '/marketplace/$artworkId': {
      id: '/marketplace/$artworkId';
      path: '/marketplace/$artworkId';
      fullPath: '/marketplace/$artworkId';
      preLoaderRoute: typeof MarketplaceArtworkIdRoute;
      parentRoute: typeof rootRoute;
    };
    '/certificate/$code': {
      id: '/certificate/$code';
      path: '/certificate/$code';
      fullPath: '/certificate/$code';
      preLoaderRoute: typeof CertificateCodeRoute;
      parentRoute: typeof rootRoute;
    };
    '/passport/$passportId': {
      id: '/passport/$passportId';
      path: '/passport/$passportId';
      fullPath: '/passport/$passportId';
      preLoaderRoute: typeof PassportPassportIdRoute;
      parentRoute: typeof rootRoute;
    };
    '/passport/order/$orderId': {
      id: '/passport/order/$orderId';
      path: '/passport/order/$orderId';
      fullPath: '/passport/order/$orderId';
      preLoaderRoute: typeof PassportOrderOrderIdRoute;
      parentRoute: typeof rootRoute;
    };
    '/passport/transfer/$transferId': {
      id: '/passport/transfer/$transferId';
      path: '/passport/transfer/$transferId';
      fullPath: '/passport/transfer/$transferId';
      preLoaderRoute: typeof PassportTransferTransferIdRoute;
      parentRoute: typeof rootRoute;
    };
    '/transfer/$transferId': {
      id: '/transfer/$transferId';
      path: '/transfer/$transferId';
      fullPath: '/transfer/$transferId';
      preLoaderRoute: typeof TransferTransferIdRoute;
      parentRoute: typeof rootRoute;
    };
    '/verify/$uuid': {
      id: '/verify/$uuid';
      path: '/verify/$uuid';
      fullPath: '/verify/$uuid';
      preLoaderRoute: typeof VerifyUuidRoute;
      parentRoute: typeof rootRoute;
    };
  }
}

const MarketplaceIndexRouteWithChildren = MarketplaceIndexRoute.update({
  id: '/marketplace/',
  path: '/marketplace',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/marketplace/index.lazy').then((d) => d.Route));

const AdminTransfersRouteWithChildren = AdminTransfersRoute.update({
  id: '/admin/transfers',
  path: '/admin/transfers',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/transfers.lazy').then((d) => d.Route));

const AdminPassportOrdersRouteWithChildren = AdminPassportOrdersRoute.update({
  id: '/admin/passport-orders',
  path: '/admin/passport-orders',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/passport-orders.lazy').then((d) => d.Route));

const AdminTagsRouteWithChildren = AdminTagsRoute.update({
  id: '/admin/tags',
  path: '/admin/tags',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/tags.lazy').then((d) => d.Route));

const AdminTransfersTransferIdRouteWithChildren = AdminTransfersTransferIdRoute.update({
  id: '/admin/transfers/$transferId',
  path: '/admin/transfers/$transferId',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/transfers.$transferId.lazy').then((d) => d.Route));

const MarketplaceArtworkIdRouteWithChildren = MarketplaceArtworkIdRoute.update({
  id: '/marketplace/$artworkId',
  path: '/marketplace/$artworkId',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/marketplace/$artworkId.lazy').then((d) => d.Route));

const CertificateCodeRouteWithChildren = CertificateCodeRoute.update({
  id: '/certificate/$code',
  path: '/certificate/$code',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/certificate/$code.lazy').then((d) => d.Route));

const PassportPassportIdRouteWithChildren = PassportPassportIdRoute.update({
  id: '/passport/$passportId',
  path: '/passport/$passportId',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/passport/$passportId.lazy').then((d) => d.Route));

const PassportOrderOrderIdRouteWithChildren = PassportOrderOrderIdRoute.update({
  id: '/passport/order/$orderId',
  path: '/passport/order/$orderId',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/passport/order.$orderId.lazy').then((d) => d.Route));

const PassportTransferTransferIdRouteWithChildren = PassportTransferTransferIdRoute.update({
  id: '/passport/transfer/$transferId',
  path: '/passport/transfer/$transferId',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/passport/transfer.$transferId.lazy').then((d) => d.Route));

const TransferTransferIdRouteWithChildren = TransferTransferIdRoute.update({
  id: '/transfer/$transferId',
  path: '/transfer/$transferId',
  getParentRoute: () => rootRoute,
});

const VerifyUuidRouteWithChildren = VerifyUuidRoute.update({
  id: '/verify/$uuid',
  path: '/verify/$uuid',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/verify/$uuid.lazy').then((d) => d.Route));

export const passportChildren = {
  MarketplaceIndexRoute: MarketplaceIndexRouteWithChildren,
  AdminTransfersRoute: AdminTransfersRouteWithChildren,
  AdminPassportOrdersRoute: AdminPassportOrdersRouteWithChildren,
  AdminTagsRoute: AdminTagsRouteWithChildren,
  AdminTransfersTransferIdRoute: AdminTransfersTransferIdRouteWithChildren,
  MarketplaceArtworkIdRoute: MarketplaceArtworkIdRouteWithChildren,
  CertificateCodeRoute: CertificateCodeRouteWithChildren,
  PassportPassportIdRoute: PassportPassportIdRouteWithChildren,
  PassportOrderOrderIdRoute: PassportOrderOrderIdRouteWithChildren,
  PassportTransferTransferIdRoute: PassportTransferTransferIdRouteWithChildren,
  TransferTransferIdRoute: TransferTransferIdRouteWithChildren,
  VerifyUuidRoute: VerifyUuidRouteWithChildren,
};
